import { isEmpty as isEmptyFunction } from 'lodash';

export function isEmpty(value) {
    return isEmptyFunction(value);
}
